module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Stairs-db12601d7c34d61599188eb669eb75e710d4998e41616322125022173fe7e5db.svg";